import { DomainEntityConfiguration } from '@web-config-app/core';
import { useConfigApp } from '../use-config-app/use-config-app';

interface UseEntityConfigProps {
  entityId?: string;
}

/**
 * Returns the DomainEntityConfiguration for the given entity ID, or
 * `undefined` when the ID is missing or not found in the tenant's
 * entity configs.
 *
 * Returns `undefined` instead of throwing so that callers (e.g.
 * `useResolvedEntity`) can distinguish "not found" from "still loading"
 * and render a friendly error page rather than crashing the outlet.
 * The return type enforces that consumers handle the undefined case.
 */
export const useEntityConfig = ({
  entityId,
}: UseEntityConfigProps): DomainEntityConfiguration | undefined => {
  const { entityConfigs } = useConfigApp();

  if (!entityId) {
    return undefined;
  }

  return entityConfigs[entityId];
};
